import { FETCH_INSTITUTION_AFFLIATIONS, PUT_INSTITUTION_AFFILIATION } from 'stores/redux/actions/types';

import hOReducer from '../common/reducer';

const formReducerValue = {
  statusCode: null,
  message: ''
};
export const fetchReducer = hOReducer(FETCH_INSTITUTION_AFFLIATIONS);
export const formReducer = hOReducer(PUT_INSTITUTION_AFFILIATION, formReducerValue);
